import { render, staticRenderFns } from "./FolderAddIcon.vue?vue&type=template&id=04efd96a&"
import script from "./FolderAddIcon.vue?vue&type=script&lang=js&"
export * from "./FolderAddIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports